import $ from 'jquery';
import { forEach } from 'lodash';
import 'slick-carousel';

import { push } from '../../01-helpers/utilities/tag-manager';

const
    moduleName = 'slider',
    attributeNames = {
        ariaLabelArrow: 'aria-label'
    },
    cssClasses = {
        gaDataLayer: '.js-ga-data-layer',
        gaDataLayerCta: '.js-ga-data-layer-cta',
        gaDataLayerHeader: '.js-ga-data-layer-header',
        slickArrow: '.slick-arrow',
        slickArrowNext: '.slick-next',
        slickArrowPrev: '.slick-prev'

    },
    selectors = {
        base: `.js-${moduleName}`,
        badge: `.js-ga-data-layer-badge`,
        title: `.js-ga-data-layer-title`
    }

export default class Slider {

    constructor(baseElement) {
        this.element = baseElement;

        this.init();
    }

    init() {
        const $slider = $(this.element);

        if ($slider.hasClass('slick-initialized')) {
            return false;
        }

        $slider.slick({
            arrows: true,
            touchThreshold: 30,
            variableWidth: true
        });

        $slider.find(cssClasses.gaDataLayerCta).on('click', function () {
            const
                articleName = this.querySelector(selectors.title)?.innerText,
                articleType = this.querySelector(selectors.badge)?.innerText,
                headerName = $slider.parents(cssClasses.gaDataLayer).find(cssClasses.gaDataLayerHeader).text();

            push({
                'event': 'carrousel_article_click', // UA
                'eventName': 'carrousel_article_click', //GA4
                'header_name': headerName,  // GA4 
                'article_name': articleName, // GA4 
                'article_content_type': articleType, // GA4
                'eventCategory': 'carrousel', // UA
                'eventAction': 'article_click', // UA
                'eventLabel': headerName + ' | ' + articleName // UA
            })
        });

        $slider.find(cssClasses.slickArrow).on('click', function () {
            const
                direction = this?.getAttribute(attributeNames.ariaLabelArrow),
                headerName = $slider.parents(cssClasses.gaDataLayer).find(cssClasses.gaDataLayerHeader).text();

            push({
                'event': 'carrousel_slide_arrow', // UA
                'eventName': 'carrousel_slide_arrow', // GA4
                'header_name': headerName, // GA4
                'arrow_direction': direction, // GA4
                'eventCategory': 'carrousel', // UA
                'eventAction': 'slide_arrow_direction', // UA
                'eventLabel': direction, // UA
            })
        });
    }
}

const sliderFunction = function initSlider(elements = document.querySelectorAll(selectors.base)) {
    forEach(elements, slider => {
        new Slider(slider);
    });
}

window.initSlider = sliderFunction;

initSlider();